import { api } from "@/lib/api";

// Authenticated CSV download: fetch as blob (Bearer token travels via api interceptor),
// then trigger a browser download with the given filename.
export async function downloadCsv(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
